const NameSpace = {
  DATA: `DATA`,
  USER: `USER`,
};

export default NameSpace;
